'use strict';

var Joi = require('joi');

function _interopDefault (e) { return e && e.__esModule ? e : { 'default': e }; }

var Joi__default = /*#__PURE__*/_interopDefault(Joi);

var _Joi$string;
var actionItemSlugs = ['add-a-link', 'add-socials', 'edit-sign-up', 'share-pico-link', 'all-tasks-dismissed'];
var DashboardActionItemClicked = Joi__default["default"].object().keys({
  action: (_Joi$string = Joi__default["default"].string()).valid.apply(_Joi$string, actionItemSlugs).description('The action specific to the item clicked')
}).description('dashboard:action_item:clicked event attributes ').meta({
  name: 'DashboardActionItemClicked',
  filename: 'dashboard:action_item:clicked.model'
});
var DashboardActionItemClicked$1 = DashboardActionItemClicked;

module.exports = DashboardActionItemClicked$1;
//# sourceMappingURL=action_item_clicked.model.js.map
